import React from "react";
import { press } from "../mock/mock";
import { ExternalLink, Quote } from "lucide-react";

const Press = () => {
  return (
    <section id="press" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Press & Recognition
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              Featured in industry press across the region.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-ink/65 leading-relaxed">
              A selection of interviews and announcements where my work at GCG Enterprise Solutions
              has been covered by regional tech media and industry analysts.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {press.map((p) => (
            <a
              key={p.id}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              className="lift-card group relative bg-ivory-50 border border-ink/10 p-8 rounded-sm flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="text-[11px] uppercase tracking-[0.22em] text-bronze font-medium">
                  {p.source}
                </span>
                <ExternalLink className="h-4 w-4 text-ink/35 group-hover:text-bronze transition-colors" />
              </div>

              <div className="text-[11px] uppercase tracking-[0.22em] text-ink/45 mb-3">
                {p.date} · {p.tag}
              </div>

              <h3 className="font-serif-display text-xl text-ink leading-snug mb-4 group-hover:text-ink-700 transition-colors">
                {p.title}
              </h3>

              <p className="text-sm text-ink/70 leading-relaxed mb-5">{p.summary}</p>

              <div className="mt-auto pt-5 border-t border-ink/10">
                <div className="flex gap-3">
                  <Quote className="h-4 w-4 text-bronze/60 flex-shrink-0 mt-0.5" />
                  <p className="text-[13px] italic text-ink/70 leading-relaxed">“{p.quote}”</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Press;
